import { Box, Typography, Button, Container, Grid } from "@mui/material";
import Layout from "../components/layout/LandingPageLayout";
import { Link } from "react-router-dom";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import GavelIcon from "@mui/icons-material/Gavel";

const ComplianceInfo = () => {
  return (
    <Layout>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Box
          sx={{
            p: 4,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 3,
            textAlign: "center",
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            sx={{
              color: "primary.main",
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Compliance Management
          </Typography>

          {/* Intro */}
          <Typography variant="body1" sx={{ color: "text.secondary", mb: 2 }}>
            Stay ahead with our intelligent compliance management system.
          </Typography>

          <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
            We help you handle statutory filings, deadlines, and compliance
            tracking with ease. From company registration to regular legal
            updates, everything is streamlined in one place.
          </Typography>

          {/* Features */}
          <Grid container spacing={4} justifyContent="center" sx={{ mb: 4 }}>
            <Grid item xs={12} sm={4}>
              <Box sx={{ textAlign: "center" }}>
                <EventAvailableIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                <Typography variant="h6" fontWeight="bold">Deadline Tracking</Typography>
                <Typography variant="body2" color="text.secondary">
                  Never miss due dates with built-in compliance calendar and reminders.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ textAlign: "center" }}>
                <NotificationsActiveIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                <Typography variant="h6" fontWeight="bold">Smart Alerts</Typography>
                <Typography variant="body2" color="text.secondary">
                  Receive instant notifications about filings, renewals, and updates.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ textAlign: "center" }}>
                <GavelIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                <Typography variant="h6" fontWeight="bold">Legal Updates</Typography>
                <Typography variant="body2" color="text.secondary">
                  Stay compliant with auto-updated laws, rules, and government policies.
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Benefits */}
          <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
            Our compliance solution ensures transparency, reduces risks of penalties,
            and gives you peace of mind — so you can focus on growing your business
            while we take care of the regulations.
          </Typography>

          {/* CTAs */}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              component={Link}
              to="/login"
              variant="contained"
              color="primary"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Get Started with Compliance
            </Button>

       
          </Box>
        </Box>
      </Container>
    </Layout>
  );
};

export default ComplianceInfo;

